import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ServicesSection } from '../components/ServicesSection';
import { VirtualTryOn } from '../components/VirtualTryOn';
import { ReviewsSection } from '../components/ReviewsSection';
import { ShopFramesSection } from '../components/ShopFramesSection';
import { PayBillSection } from '../components/PayBillSection';
export function ServicesPage() {
  return <>
      <PageHeader title="Our Services" backgroundImage="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=1920&q=80" data-id="element-1034" />
      <ServicesSection data-id="element-1035" />
      <VirtualTryOn data-id="element-1036" />
      <PayBillSection data-id="element-1037" />
      <ShopFramesSection data-id="element-1038" />
      <ReviewsSection data-id="element-1039" />
    </>;
}